import React, { Component } from 'react';
import BreadCrumbs from '../../../Shared/BreadCrumbs/BreadCrumbs';
import { dateFormatter, successToastr, warningToastr } from '../../../../HelperMethods';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { Form, Formik } from 'formik';
import Collapsible from 'react-collapsible';
import Skeleton from 'react-loading-skeleton';
import { convertShiftDateTime, ErrorComponent } from '../../../ReusableComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { REPORT_PERMISSION_CREATED_SUCCESS_MSG, REPORT_PERMISSION_PERMISSION_WARNING_MSG, REPORT_PERMISSION_UPDATED_SUCCESS_MSG } from '../../../Shared/AppMessages';
import { MANAGE_REPORT_PERMISSION } from '../../../Shared/ApiUrls';
import ReportingPermissionDataService from './../../Services/PermissionDataServices';
import { history } from "../../../../HelperMethods";
import CommonControl from '../../../Shared/UserAndRoleControl/CommonControl';
import withValueField from '../../../Shared/withValueField';
import { reportPermissionValidation } from './Validations/Validations';
import PermissionDataServices from './../../Services/PermissionDataServices';
import { IDropDownModel } from '../../../Shared/Models/IDropDownModel';
import { filterBy } from "@progress/kendo-data-query";
import { getAllReport, getAllReportFile } from '../../Services/DataServices';
import lookupDataService from '../../../Lookup/Services';

const CustomDropDownList = withValueField(DropDownList);
const defaultItemCategory = { name: "Select Category", id: null };
const defaultItemReport = { name: "Select Report", id: null };
const defaultItem = { name: "Select..", id: null };

export enum ALLSELECTED {
    ALLUSERTYPE = "All User Type",
}

interface CreateReportPermissionProps {
    props: any;
    match: any;
}

interface CreateReportPermissionState {
    reportPermissionId: string;
    reportName: string;
    category: string;
    description: string;
    isPublic?: boolean;
    clients: any;
    selectedClients: any;
    clientIds: any;
    userType: any;
    userTypeId?: any;
    usersAndRoles: any;
    userTypes: any;
    selectedUserType: any;
    isAllUserTypeSelected?: boolean;
    modifiedDate?: any;
    createdDate?: any;
    save?: boolean;
    isDirty?: boolean;
    toggelFirst: boolean;
    toggelSecond: boolean;
    showLoader: boolean;
    submitted: boolean;
    vendors: any;
    vendorId: any;

    reports?: Array<IDropDownModel>;
    originalreports?: Array<IDropDownModel>;
    reportsFile?: Array<IDropDownModel>;
    originalreportsFile?: Array<IDropDownModel>;
    isUserTypeVendor?: boolean;
    originalclients?: Array<IDropDownModel>;
    originalvendors?: Array<IDropDownModel>;
}

class CreateReportPermission extends Component<CreateReportPermissionProps, CreateReportPermissionState> {
    public commonControl: any;
    constructor(props: CreateReportPermissionProps) {
        super(props);
        const { id } = this.props.match.params;
        this.state = {
            reportPermissionId: id,
            toggelFirst: true,
            toggelSecond: true,
            showLoader: true,
            isDirty: false,
            reportName: "",
            category: "",
            description: "",
            isPublic: true,
            clients: [],
            selectedClients: [],
            userType: [],
            usersAndRoles: [],
            userTypes: [],
            selectedUserType: [],
            clientIds: [],
            submitted: false,
            vendors: [],
            vendorId: [],
            isUserTypeVendor: false,
            originalreportsFile: [],
            originalreports: [],
            originalclients: [],
            originalvendors: [],
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.getAllReportsFile();
        this.getClients();
        this.getVendor(null);
        this.getUserType();
        if (this.state.reportPermissionId) {
            this.getReportPermisionDetails(this.state.reportPermissionId);
        }
    }

    saveReportPermission = (isSubmit: boolean) => {
        let isValid = this.checkValidations();
        if (isValid) {
            let data = {
                reportPermissionId: this.state.reportPermissionId,
                reportName: this.state.reportName,
                category: this.state.category,
                description: this.state.description,
                isPublic: this.state.isPublic,
                clients: this.state.selectedClients,
                usersRoles: JSON.stringify(this.state.usersAndRoles),
                VendorIds: JSON.stringify(this.state.vendorId),
                userType: this.state.selectedUserType ? JSON.stringify(this.state.selectedUserType.filter(x => x.id !== 9999)) : JSON.stringify([]),
            };

            if (this.state.reportPermissionId) {
                ReportingPermissionDataService.putReportPermission(data).then((res) => {
                    successToastr(REPORT_PERMISSION_UPDATED_SUCCESS_MSG);
                    history.push(MANAGE_REPORT_PERMISSION);
                });
            } else {
                ReportingPermissionDataService.postReportPermission(data).then((res) => {
                    successToastr(REPORT_PERMISSION_CREATED_SUCCESS_MSG);
                    history.push(MANAGE_REPORT_PERMISSION);
                });
            }
        }
    }

    checkValidations() {
        if (!this.state.isPublic
            && (this.state.selectedClients.length < 1 && (this.state.selectedUserType.length < 1 && this.state.usersAndRoles.length < 1))) {
            warningToastr(REPORT_PERMISSION_PERMISSION_WARNING_MSG);
            return false;
        }

        // if((this.state.selectedUserType.length < 0 || this.state.usersAndRoles.length < 1)){
        //     warningToastr(REPORT_PERMISSION_PERMISSION_WARNING_MSG);
        //     return false;
        // }
        return true;
    }

    getReportPermisionDetails = (ReportPermisionId: string) => {
        ReportingPermissionDataService.getReportPermisionDetails(ReportPermisionId).then((res: any) => {
            const { data } = res;
            this.setState({
                reportPermissionId: data.id,
                reportName: data.reportName,
                category: data.category,
                description: data.description,
                isPublic: data.isPublic,
                selectedClients: data.clientIds,
                clientIds: data.clientIds,
                vendorId: JSON.parse(data.vendorIds),
                usersAndRoles: JSON.parse(data.usersRoles),
                selectedUserType: JSON.parse(data.userType),
                modifiedDate: new Date(data.modifiedDate),
                createdDate: new Date(data.createdDate),
                showLoader: false,
            }, () => {
                this.getUserType()
                this.getAllReports(this.state.category);
                if (!this.state.isPublic && (this.state.clientIds.length || this.state.selectedUserType.length)) {
                    var selectedUsers = this.state.selectedUserType?.filter(x => x.id != 9999).map(x => x.userTypeIntId)
                    this.commonControl.getUserAndRoles(this.state.clientIds.map(x => x.id), selectedUsers, this.state.vendorId.map(x => x.id), true)
                    this.setUserTypeVendor(this.state.selectedUserType);
                    if (this.state.clientIds.length > 0 && this.state.vendorId) { this.getVendor(this.state.clientIds); }
                }
            });
        });
    }

    itemRender = (li, itemProps) => {
        const itemChildren = (
            <span>
                <input
                    type="checkbox"
                    checked={itemProps.dataItem.name == ALLSELECTED.ALLUSERTYPE ? this.state.isAllUserTypeSelected :
                        itemProps.selected}
                    onChange={(e) => itemProps.onClick(itemProps.index, e)}
                />
                &nbsp;{li.props.children}
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    handleChange = (e) => {
        let { name, value } = e.target;
        this.state[name] = value;
        this.setState(this.state);
    };

    handleObjChange = (change) => {
        this.setState(change);
    }

    handleCheckboxChange(e, modelProp) {
        var stateObj = {};
        stateObj[modelProp] = e.target.type == "checkbox" ? e.target.checked : e.target.value;
        this.setState(stateObj);
        if (e.target.checked) {
            this.setState({
                selectedClients: [],
                usersAndRoles: [],
                selectedUserType: [],
                vendorId: []
            })
        }
    }

    onCollapseOpen = () => {
        this.setState({
            toggelFirst: true,
            toggelSecond: true,
        });
    };

    onCollapseClose = () => {
        this.setState({
            toggelFirst: false,
            toggelSecond: false,
        });
    };

    handlePropsChange = (change) => {
        this.setState({
            showLoader: change
        });
    };

    handleClientsChange = (e) => {
        var selectedUser = this.state.selectedUserType ? this.state.selectedUserType.filter(x => x.id != 9999).map(x => x.userTypeIntId) : [];
        this.setState({ clientIds: e.value, selectedClients: e.value },
            () => {
                if (this.state.clientIds.length == 0) {
                    if (selectedUser.length == 0) {
                        this.setState({ usersAndRoles: [], vendorId: [] });
                        this.commonControl.handlePropObjChange();
                    } else {
                        this.commonControl.getUserAndRoles(this.state.clientIds.map(x => x.id), selectedUser, this.state.vendorId.map(x => x.id), true)
                        if (this.state.selectedUserType.filter(x => x.name == 'Vendor').length > 0) {
                            this.getVendor(e.value);
                        } else {
                            this.setState({ vendorId: [] });
                        }
                    }
                } else {
                    this.commonControl.getUserAndRoles(this.state.clientIds.map(x => x.id), selectedUser, this.state.vendorId.map(x => x.id), true)
                    if (this.state.selectedUserType.filter(x => x.name == 'Vendor').length > 0) {
                        this.getVendor(e.value);
                    } else {
                        this.setState({ vendorId: [] });
                    }
                }
            })
    }

    getUserType() {
        ReportingPermissionDataService.getUserType()
            .then(async (res: any) => {
                res.data.unshift({ name: ALLSELECTED.ALLUSERTYPE, id: 9999 });
                this.setState({
                    userTypes: res.data,
                    showLoader: false,
                });

                if (this.state.selectedUserType) {
                    this.setState({
                        isAllUserTypeSelected: this.state.selectedUserType.length === res.data.length - 1
                    })
                }
            });
    }

    handleChangeUserType = (e) => {
        var isAllSelected = false;
        var selectedUserTypes = e.value.filter(
            (x) => x.id != undefined && x.id != null && x.id != 9999
        );
        let Id = selectedUserTypes.map((loc) => loc.id);

        if (e.nativeEvent.target.innerText?.trim() === ALLSELECTED.ALLUSERTYPE
            || (e.nativeEvent.target.nextSibling != null && e.nativeEvent.target.nextSibling.nextSibling != null
                && e.nativeEvent.target.nextSibling.nextSibling.wholeText != null && e.nativeEvent.target.nextSibling.nextSibling.wholeText != undefined
                && e.nativeEvent.target.nextSibling.nextSibling.wholeText?.trim() === ALLSELECTED.ALLUSERTYPE)) {
            if (!this.state.isAllUserTypeSelected) {
                isAllSelected = true;
                var vendors = this.state.userTypes.filter(
                    (x) => x.id != undefined && x.id != null && x.id != 9999
                );

                Id = vendors.map((x) => x.id);
                selectedUserTypes = this.state.userTypes;
            } else {
                selectedUserTypes = [];
                Id = null;
            }
        } else {
            if (selectedUserTypes.length == (this.state.userTypes.length - 1)) {
                selectedUserTypes.unshift({ name: ALLSELECTED.ALLUSERTYPE, id: 9999 });
                isAllSelected = true;
            }
        }

        if (selectedUserTypes.length == 0) {
            this.commonControl.handlePropObjChange();
        }

        this.setUserTypeVendor(selectedUserTypes);

        this.setState({
            selectedUserType: selectedUserTypes,
            isAllUserTypeSelected: isAllSelected
        })

        var selectedUsers = selectedUserTypes.filter(x => x.id != 9999).map(x => x.userTypeIntId);
        if (this.state.clientIds.length || selectedUsers.length) {
            this.commonControl.getUserAndRoles(this.state.clientIds.map(x => x.id), selectedUsers, this.state.vendorId.map(x => x.id), true)
        }
    }

    setUserTypeVendor = (selectedUserTypes) => {
        if (selectedUserTypes.filter(x => x.name == 'Vendor').length > 0) {
            this.setState({ isUserTypeVendor: true });
            this.getVendor(this.state.clientIds);
        } else {
            this.setState({ isUserTypeVendor: false, vendorId: [] });
        }
    }

    getClients = () => {
        lookupDataService.getClientsLookup().then((res) => {
            this.setState({
                clients: res.data,
                originalclients: res.data,
                showLoader: false,
            });
        });
    }

    getVendor = (selectedClients) => {
        var queryParams = '';

        if (selectedClients != undefined && selectedClients != null && selectedClients.length > 0) {
            var clientIds = selectedClients.map(x => x.id);
            if (clientIds.length) {
                queryParams += `$filter= clientId eq null or clientId in ('${clientIds.join("','")}')`
                lookupDataService.getVendorsLookup(queryParams).then(async res => {
                    this.setState({
                        vendors: res.data,
                        originalvendors: res.data
                    });
                });
            } else {
                this.setState({ vendors: [], vendorId: [] });
            }
        } else {
            this.setState({ vendors: [], vendorId: [] });
        }
    }

    handleVendorChange = (e) => {
        this.setState({ vendorId: e.value },
            () => {
                if (this.state.vendorId.length == 0) {
                } else {
                    var selectedUser = this.state.selectedUserType ? this.state.selectedUserType.filter(x => x.id != 9999).map(x => x.userTypeIntId) : [];
                    this.commonControl.getUserAndRoles(this.state.clientIds.map(x => x.id), selectedUser, this.state.vendorId.map(x => x.id), true)
                }
            });
    }

    handleReportChange = (e) => {
        const id = e.target.value;
        const selectedReport = this.state.reports.find(report => report.id === id);

        this.setState({
            reportName: id,
        });
    }

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    getAllReports = (folder) => {
        getAllReport(folder).then((res: any) => {
            this.setState({
                reports: res.data.files.map(file => ({
                    name: this.removeExtension(file.fileName),
                    id: this.removeExtension(file.fileName)
                })),
                originalreports: res.data.files.map(file => ({
                    name: this.removeExtension(file.fileName),
                    id: this.removeExtension(file.fileName)
                }))
            });
        });
    };

    getAllReportsFile = () => {
        getAllReportFile().then((res) => {
            this.setState({
                reportsFile: res.data.folders.map((data) => ({
                    name: data.name,
                    id: data.name
                })),
                originalreportsFile: res.data.folders.map((data) => ({
                    name: data.name,
                    id: data.name
                }))
            });
        });
    };

    removeExtension = (e) => {
        return e.slice(0, -5);
    }

    handleReportFileChange = (e) => {
        if (!e.target.value) {
            this.setState({
                reportName: null,
                reports: [],
                category: null,
            })
            return;
        }
        this.setState({
            reportName: null,
            reports: []
        });
        const id = e.target.value;
        const selectedReportName = e.target.value;
        this.setState(
            {
                category: id,

            },
            () => {
                this.getAllReports(selectedReportName);
            }
        );
    };


    render() {
        const {
            toggelFirst,
            toggelSecond,
        } = this.state;
        const reportInfoTriggerName = (
            <span>
                Report Information
            </span>
        );
        const reportPermission = (
            <span>
                Report Permissions
            </span>
        );
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="col-12">
                    <div className="row pt-2 pb-2 accordianTitleClr mx-auto mb-3 mt-3">
                        <div className="col-2 col-md-6 fonFifteen paddingLeftandRight">
                            <div className="d-none d-md-block">
                                <BreadCrumbs globalData={{ reportPermissionId: this.state.reportPermissionId }}></BreadCrumbs>
                            </div>
                        </div>
                        <div className="col-10 col-md-6 text-right mt-sm-1 mt-md-0 txt-orderno text-underline paddingRight d-flex align-items-center justify-content-end ">
                            {this.state.reportPermissionId &&
                                <span className="float-right text-dark">
                                    Last Modified : {this.state.modifiedDate && dateFormatter(this.state.modifiedDate)} {this.state.modifiedDate && convertShiftDateTime(this.state.modifiedDate)}
                                </span>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-12 ml-0 mr-0">
                    <Formik
                        validateOnMount={this.state.submitted}
                        initialValues={this.state}
                        validateOnChange={false}
                        enableReinitialize={true}
                        validationSchema={reportPermissionValidation}
                        validateOnBlur={false}
                        onSubmit={(fields) => this.saveReportPermission(true)}
                        render={(formikProps) => (
                            <Form className="col-12 ml-0 mr-0" id="collapsiblePadding" translate="yes" onChange={formikProps.handleChange}>
                                <div className="row mt-2">
                                    <div className="col-12 px-0 mt-2 ml-0 mr-0">
                                        <Collapsible
                                            trigger={reportInfoTriggerName}
                                            open={toggelFirst}
                                            accordionPosition="1"
                                            onTriggerOpening={() => this.setState({ toggelFirst: true })}
                                            onTriggerClosing={() => this.setState({ toggelFirst: false })}
                                        >
                                            {this.state.showLoader &&
                                                Array.from({ length: 2 }).map((item, i) => (
                                                    <div className="row mx-auto mt-2" key={i}>
                                                        {Array.from({ length: 3 }).map((item, j) => (
                                                            <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                                                <Skeleton width={100} />
                                                                <Skeleton height={30} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            {!this.state.showLoader &&
                                                <div className="col-12 px-0">
                                                    <div className="row mt-2">
                                                        <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                                            <label className="mb-1 font-weight-bold required">Category</label>
                                                            <CustomDropDownList
                                                                className="form-control mt-1"
                                                                data={this.state.reportsFile}
                                                                textField="name"
                                                                valueField="id"
                                                                id="reportsFile"
                                                                name="id"
                                                                value={this.state.category}
                                                                defaultItem={defaultItemCategory}
                                                                onChange={(e) => this.handleReportFileChange(e)}
                                                                filterable={this.state.originalreportsFile.length > 5 ? true : false}
                                                                onFilterChange={this.handleFilterChange}
                                                            />
                                                            {(this.state.category == undefined || this.state.category == null || formikProps.errors.category) && <ErrorComponent message={formikProps.errors.category} />}

                                                        </div>
                                                        <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                                            <label className="mb-1 font-weight-bold required">Report Name</label>
                                                            <CustomDropDownList
                                                                className="form-control mt-1"
                                                                data={this.state.reports}
                                                                textField="name"
                                                                valueField="id"
                                                                id="reports"
                                                                name="id"
                                                                value={this.state.reportName}
                                                                defaultItem={defaultItemReport}
                                                                onChange={(e) => this.handleReportChange(e)}
                                                                filterable={this.state.originalreports.length > 5 ? true : false}
                                                                onFilterChange={this.handleFilterChange}
                                                            />
                                                            {(this.state.reportName == undefined || this.state.reportName == null || formikProps.errors.reportName) && <ErrorComponent message={formikProps.errors.reportName} />}

                                                        </div>
                                                        <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1">
                                                            <label className="mb-1 font-weight-bold required">Description</label>
                                                            <textarea
                                                                rows={3}
                                                                id="description"
                                                                name="description"
                                                                value={this.state.description}
                                                                className="form-control"
                                                                placeholder="Enter Description"
                                                                maxLength={500}
                                                                onChange={(event) => {
                                                                    this.setState({ description: event.target.value });
                                                                }}
                                                            />
                                                            {formikProps.errors.description && <ErrorComponent message={formikProps.errors.description} />}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-sm-4 mt-1 mt-sm-0 d-flex">
                                                            <div className="ml-1">
                                                                <label className="mb-1 font-weight-bold">Public</label>
                                                                <label className="container-R d-flex mb-0 pb-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        value="false"
                                                                        onChange={(e) => this.handleCheckboxChange(e, "isPublic")}
                                                                        checked={this.state.isPublic}
                                                                    />
                                                                    <span className="checkmark-R checkPosition checkPositionTop" style={{ left: "0px" }}></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </Collapsible>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12 px-0 ml-0 mr-0">
                                        <Collapsible
                                            lazyRender={true}
                                            trigger={reportPermission}
                                            open={toggelSecond}
                                            onTriggerOpening={() => this.setState({ toggelSecond: true })}
                                            onTriggerClosing={() => this.setState({ toggelSecond: false })}
                                        >
                                            {this.state.showLoader &&
                                                Array.from({ length: 2 }).map((item, i) => (
                                                    <div className="row mx-auto mt-2" key={i}>
                                                        {Array.from({ length: 3 }).map((item, j) => (
                                                            <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                                                <Skeleton width={100} />
                                                                <Skeleton height={30} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            {!this.state.showLoader &&
                                                <div className="row mt-2">
                                                    <div className="col-12 col-sm-4 col-lg-4 mt-3 area-merged multiselect">
                                                        <label className="mb-1 font-weight-bold">Clients</label>
                                                        <MultiSelect
                                                            className="form-control disabled"
                                                            textField="name"
                                                            dataItemKey="id"
                                                            id="clients"
                                                            data={this.state.clients}
                                                            itemRender={this.itemRender}
                                                            name="client"
                                                            value={this.state.selectedClients}
                                                            onChange={(e) => this.handleClientsChange(e)}
                                                            placeholder="Select Clients..."
                                                            disabled={this.state.isPublic}
                                                            filterable={this.state.originalclients.length > 5 ? true : false}
                                                            onFilterChange={this.handleFilterChange}
                                                        />
                                                        {formikProps.errors.selectedClients && (<ErrorComponent message={formikProps.errors.selectedClients} />)}
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-4 mt-3 multiselect">
                                                        <label className="mb-1 font-weight-bold">User Type</label>
                                                        <MultiSelect
                                                            className={"form-control disabled "}
                                                            data={this.state.userTypes}
                                                            textField="name"
                                                            dataItemKey="id"
                                                            id="userType"
                                                            name="userType"
                                                            placeholder="Select User Type"
                                                            value={this.state.selectedUserType && this.state.selectedUserType.filter((x) => x.id != 9999)}
                                                            onChange={(e) => this.handleChangeUserType(e)}
                                                            itemRender={this.itemRender}
                                                            disabled={this.state.isPublic}
                                                        />
                                                    </div>
                                                    {this.state.isUserTypeVendor == true && (<div className="col-12 col-sm-4 col-lg-4 mt-3 multiselect">
                                                        <label className="mb-1 font-weight-bold ">
                                                            <span>Vendor</span>
                                                        </label>
                                                        <MultiSelect
                                                            className="form-control disabled"
                                                            textField="name"
                                                            dataItemKey="id"
                                                            id="vendors"
                                                            data={this.state.vendors}
                                                            itemRender={this.itemRender}
                                                            name="vendor"
                                                            value={this.state.vendorId}
                                                            onChange={(e) => this.handleVendorChange(e)}
                                                            placeholder="Select Vendors..."
                                                            disabled={this.state.clientIds.length === 0 || this.state.isPublic || !this.state.isUserTypeVendor}
                                                            filterable={this.state.originalvendors.length > 5 ? true : false}
                                                            onFilterChange={this.handleFilterChange}
                                                        />
                                                    </div>)}
                                                    <div className="col-12 col-sm-4 col-lg-4 mt-3 common-control_padding">
                                                        <label className="mb-1 font-weight-bold">Users & Roles</label>
                                                        <CommonControl
                                                            disabled={this.state.isPublic}
                                                            ref={(instance) => {
                                                                this.commonControl = instance;
                                                            }}
                                                            value={this.state.usersAndRoles}
                                                            id="usersAndRoles"
                                                            handleChange={this.handleChange}
                                                            handleObjChange={this.handleObjChange}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </Collapsible>
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-center border-0 mt-2">
                                    <div className="modal-footer justify-content-center border-0 mt-2">
                                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                                            </button>
                                            <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={() => this.setState({ submitted: true, save: false })}>
                                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    />
                </div>
            </div>
        )
    }
}

export default CreateReportPermission;